[
 {
  "id": "c1",
  "x": 96,
  "y": 948,
  "w": 126,
  "h": 142
 },
 {
  "id": "c2",
  "x": 222,
  "y": 948,
  "w": 126,
  "h": 142
 },
 {
  "id": "c3",
  "x": 348,
  "y": 948,
  "w": 126,
  "h": 142
 },
 {
  "id": "c4",
  "x": 474,
  "y": 948,
  "w": 126,
  "h": 142
 },
 {
  "id": "c5",
  "x": 600,
  "y": 948,
  "w": 126,
  "h": 142
 },
 {
  "id": "c6",
  "x": 726,
  "y": 948,
  "w": 126,
  "h": 142
 }
]